export { TickIcon } from './tick-icon';
